import React from "react";
import CustomerListingCard from "../CustomerListingCard/CustomerListingCard";
import { Box } from "@mui/material";
import { CustomerListingResponsiveStyles } from "./CustomerListingResponsiveStyles";

interface CustomerListCardProps {
  customerListingData: {
    customerName: string;
    entityType: string;
    address: {
      addr1: string;
      addrTypeCd: string;
      city: string;
      county: string;
      postalCode: string;
      regionCd: string;
      regionISOCd: string;
      stateProvCd: string;
    };
  }[];
}

const CustomerListCards: React.FC<CustomerListCardProps> = ({
  customerListingData,
}) => {
  return (
    <Box sx={CustomerListingResponsiveStyles.customerListingContainer}>
      <Box sx={CustomerListingResponsiveStyles.container}>
        {customerListingData.map((customer, index) => (
          <CustomerListingCard
            key={index}
            name={customer.customerName}
            entityType={customer.entityType}
            address={`${customer.address.addr1} ${customer.address.addrTypeCd}, ${customer.address.city}, ${customer.address.county}, ${customer.address.stateProvCd} ${customer.address.postalCode} ${customer.address.regionISOCd} ${customer.address.regionCd}`}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CustomerListCards;
